export default __webpack_public_path__ + "static/media/bannerImage.1d73257f.png";